export default "__VITE_ASSET__BtHchh$M__"